import { trimNullableString } from "./SanitizationHelpers";
import { ISLLineItemPostBody } from "../schemas/SLLineItemPostBody";
import { IComboBoxOption } from "@fluentui/react";
import { AccountTypeOptions } from "../components/SLCreate/SLCreateLineItems/LineItemsUtilities";
import { LineItemProperty } from "../components/SLCreate/SLCreateLineItems/LineItemsSchemas";

export default class SLEntryLineItemsFactory {
  private readonly accountType: IComboBoxOption[] = AccountTypeOptions;

  private mapAccountTypeKeyValue = (inputAccountType: string, isKey: boolean): string | undefined => {
    let outputAccountType = trimNullableString(inputAccountType) as string;
    if (isKey) {
      const acc = this.accountType
        .slice(1)
        .filter((keyValue) => (keyValue.key as string).toUpperCase() === outputAccountType.toUpperCase());
      if (acc.length > 0) {
        outputAccountType = acc[0].text;
      }
    } else {
      const acc = this.accountType
        .slice(1)
        .filter((textValue) => textValue.text.toUpperCase() === outputAccountType.toUpperCase());
      if (acc.length > 0) {
        outputAccountType = acc[0].key as string;
      }
    }
    return outputAccountType;
  };

  public lineItemListSanitationForGetEntry(lineItemsList: LineItemProperty[]): LineItemProperty[] {
    const lineItems = lineItemsList.map((lineItemRow: any) => {
      return {
        account: lineItemRow.account,
        accountType: this.mapAccountTypeKeyValue(lineItemRow.accountType, true),
        costCenter: lineItemRow.costCenter,
        internalOrder: lineItemRow.internalOrder,
        taxCode: lineItemRow.taxCode,
        taxJurisdictionCode: lineItemRow.taxJurisdictionCode,
        materialGroup: lineItemRow.materialGroup,
        tradingPartner: lineItemRow.tradingPartner,
        profitCenter: lineItemRow.profitCenter,
        lineAmount: lineItemRow.lineAmount,
        lineDesc: lineItemRow.lineDesc
      } as any;
    });
    return lineItems as LineItemProperty[];
  }

  public lineItemListSanitationForPostEntry(lineItemsList: string[][]): ISLLineItemPostBody[] {
    const cellHasData = (cellValue: string) => cellValue !== "" && cellValue !== undefined && cellValue !== null;
    const lineItems = lineItemsList.reduce((items, lineItemRow: string[]) => {
      if (Object.entries(lineItemRow).length === 0 && lineItemRow.constructor === Object) {
        // row is an empty object
        return items;
      } else if (lineItemRow.length !== 11) {
        // row has wrong number of columns
        return items;
      }
      if (lineItemRow.some(cellHasData)) {
        items.push({
          AccountType: this.mapAccountTypeKeyValue(lineItemRow[0], false),
          Account: trimNullableString(lineItemRow[1]),
          CostCenter: trimNullableString(lineItemRow[2]),
          InternalOrder: trimNullableString(lineItemRow[3]),
          ProfitCenter: trimNullableString(lineItemRow[4]),
          TradingPartner: trimNullableString(lineItemRow[5]),
          MaterialGroup: trimNullableString(lineItemRow[6]),
          TaxCode: trimNullableString(lineItemRow[7]),
          TaxJurisdictionCode: trimNullableString(lineItemRow[8]),
          LineDesc: trimNullableString(lineItemRow[9]),
          LineAmount: trimNullableString(lineItemRow[10])
        });
      }
      return items;
    }, [] as ISLLineItemPostBody[]);
    return lineItems;
  }
}
